





































































import Vue from "vue";
import ApiService from "@/services/ApiService";
import { FilterItem } from "@/types";
import { FilterParameter } from "@/types/FilterParameter";

/**
 * Emits @change for filter change event
 */
export default Vue.extend({
  name: "SearchBar",
  props: {
    disableFilter: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      showSearch: false,
      showFilter: false,
      searchValue: "",
      filter: {
        query: "",
        type: "",
        department: "",
      } as FilterParameter,
      types: [] as FilterItem[],
      positions: [] as FilterItem[],
      isLoading: false,
    };
  },
  watch: {
    filter: {
      handler() {
        this.$emit("change", this.filter);
      },
      deep: true,
    },
  },
  mounted() {
    this.isLoading = true;
    Promise.all([
      ApiService.getMeldungsTypen().then(
        (res: FilterItem[]) => (this.types = [{ id: "", name: "Alle" }, ...res])
      ),
      ApiService.getMeldestellen().then(
        (res: FilterItem[]) =>
          (this.positions = [{ id: "", name: "Alle" }, ...res])
      ),
    ]).finally(() => (this.isLoading = false));
  },
  methods: {
    onSearch() {
      // open search bar if not shown
      if (!this.showSearch) this.showSearch = !this.showSearch;
      // else if no search value is entered
      else if (!this.searchValue) {
        // and the search value is change to empty
        if (this.filter.query != this.searchValue)
          // update the search query
          this.filter.query = this.searchValue;
        // else close the search bar
        else this.showSearch = !this.showSearch;
      }
      // update the search query
      else this.filter.query = this.searchValue;
    },
  },
});
